import { render, staticRenderFns } from "./PolicyVerificationPopup.vue?vue&type=template&id=76c79cd1&scoped=true"
import script from "./PolicyVerificationPopup.vue?vue&type=script&lang=js"
export * from "./PolicyVerificationPopup.vue?vue&type=script&lang=js"
import style0 from "./PolicyVerificationPopup.vue?vue&type=style&index=0&id=76c79cd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_css-loader@6.11.0_webpack@5.105.2__lodash@4_64be4d9407eb667fe9a1e2476327747d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c79cd1",
  null
  
)

export default component.exports